import { createContextWithHook } from '@chilipiper/utils'

const { PageVisibilityBaseProvider: BaseProvider, usePageVisibilityContext } =
  createContextWithHook<boolean>()('PageVisibility')

export const PageVisibilityProvider = BaseProvider

export const usePageVisibility = usePageVisibilityContext
